import{css}from"@primeuix/styled";var style=css`
    .p-orderlist {
        display: flex;
        gap: dt('orderlist.gap');
    }

    .p-orderlist-controls {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: dt('orderlist.controls.gap');
    }
`;export{style};//# sourceMappingURL=index.mjs.map